import { getData } from "api/dataVisualisation/client";
import { DataDownloadFormat } from "models/dataDownload/dataDownloadFormat";
import {
  DataDownloadModel,
  JsonDataDownloadModel,
} from "models/dataDownload/dataDownloadModel";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { SoSoTradePricesModel } from "models/soSoTradePrices/soSoTradePricesModel";

export const getSoSoTradePricesData = async (
  dateFilter: DateFilterModel,
  format?: DataDownloadFormat
): Promise<DataDownloadModel<SoSoTradePricesModel>> => {
  const { data } = await getData(
    "/SOSO/prices",
    {
      from: dateFilter.normalisedStartDate.toISOString(),
      to: dateFilter.normalisedEndDate.toISOString(),
    },
    format
  );
  return data;
};

export const getSoSoTradePricesJsonData = (
  dateFilter: DateFilterModel
): Promise<JsonDataDownloadModel<SoSoTradePricesModel>> =>
  getSoSoTradePricesData(dateFilter, DataDownloadFormat.Json) as Promise<
    JsonDataDownloadModel<SoSoTradePricesModel>
  >;
